// src/components/Usuarios.jsx
import React, { useEffect, useState, useRef } from "react";
import clienteAxios from "../../axios";
import Dasboard from "../dasboard/dashboard"; // Importa tu dashboard aquí
import ModalConfirm from "../ModalConfirm";
import Roles from "./Roles"; // Subcomponente para roles
import ModalAgregarUsuario from "./ModalAgregarUsuario"; // Modal para agregar nuevo usuario
import { useNavigate } from "react-router-dom";

const Usuarios = () => {
    const [isLogin, setIsLogin] = useState(!!localStorage.getItem("token"));
    const [usuarios, setUsuarios] = useState([]);
    const [usuarioSeleccionado, setUsuarioSeleccionado] = useState(null);
    const [editandoUsuario, setEditandoUsuario] = useState(null);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [showAgregarUsuarioModal, setShowAgregarUsuarioModal] = useState(false);
    const [usuarioAEliminar, setUsuarioAEliminar] = useState(null);
    const [busqueda, setBusqueda] = useState("");
    const [componenteActivo, setComponenteActivo] = useState(null); // Para rastrear el subcomponente activo
    const formularioRef = useRef(null);
    const navigate = useNavigate();

 

    // Obtener lista de usuarios
    const obtenerUsuarios = async () => {
        try {
            const response = await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Listar",
                modulo: "usuarios",
            });
            setUsuarios(response.data.data[0]);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        obtenerUsuarios();
    }, []);

    // Función para manejar la búsqueda
    const handleBusqueda = (e) => {
        setBusqueda(e.target.value.toLowerCase());
    };

    // Filtrar usuarios en función de la búsqueda
    const usuariosFiltrados = usuarios.filter((usuario) =>
        usuario.nombre?.toLowerCase().includes(busqueda)
    );


    // Función para editar un usuario
    const editarUsuario = (usuario) => {
        setEditandoUsuario(usuario);
        setUsuarioSeleccionado(usuario.idusuario);
    };

    // Guardar los cambios del usuario editado
    const guardarUsuarioEditado = async () => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Actualizar",
                modulo: "usuarios",
                idusuario: editandoUsuario.idusuario,
                celular: editandoUsuario.celular,
                nombre: editandoUsuario.nombre,
                correo: editandoUsuario.correo,
                clave: editandoUsuario.clave,
                activo: editandoUsuario.activo,
                idperfil: editandoUsuario.idperfil,
            });
            setEditandoUsuario(null);
            setUsuarioSeleccionado(null);
            obtenerUsuarios(); // Actualizar la lista de usuarios
        } catch (error) {
            console.log(error);
        }
    };

    // Confirmar eliminación de un usuario
    const confirmarEliminarUsuario = (usuario) => {
        setUsuarioAEliminar(usuario);
        setShowConfirmModal(true);
    };

    const eliminarUsuario = async () => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Eliminiar",
                modulo: "usuarios",
                idusuario: usuarioAEliminar.idusuario,
            });
            setShowConfirmModal(false);
            obtenerUsuarios(); // Actualizar la lista de usuarios
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <>
            <ModalConfirm
                show={showConfirmModal}
                message="¿Estás seguro de que quieres eliminar este usuario?"
                onConfirm={eliminarUsuario}
                onCancel={() => setShowConfirmModal(false)}
            />

            {isLogin ? (
                <>
                    <Dasboard  /> {/* Mostrar el dashboard */}

                    <main className="-mt-32">
                        <div className="mx-auto max-w-7xl px-4 pb-12 sm:px-6 lg:px-8">
                            <div className="rounded-lg bg-white px-5 py-6 shadow sm:px-6 max-w-full overflow-hidden">
                                <h2 className="text-2xl font-bold mb-6 mt-4">Usuarios</h2>

                                {/* Barra de búsqueda */}
                                <input
                                    type="text"
                                    placeholder="Buscar usuario..."
                                    value={busqueda}
                                    onChange={handleBusqueda}
                                    className="border rounded-lg p-2 mb-4 w-full"
                                />

                                <ul>
                                    {usuariosFiltrados.map((usuario) => (
                                        <li
                                            key={usuario.idusuario}
                                            className="border-4 p-4 rounded-lg mb-4 cursor-pointer"
                                            onClick={() => setUsuarioSeleccionado(usuario.idusuario)}
                                        >
                                            <div className="relative">
                                                {usuarioSeleccionado === usuario.idusuario && (
                                                    <button
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            setUsuarioSeleccionado(null); // Cierra el usuario seleccionado
                                                            setEditandoUsuario(null);
                                                            setComponenteActivo(null);
                                                        }}
                                                        className="absolute top-[-1rem] right-0 text-gray-500 hover:text-red-500 p-2 text-3xl"
                                                    >
                                                        &times;
                                                    </button>
                                                )}
                                                {editandoUsuario && editandoUsuario.idusuario === usuario.idusuario ? (
                                                    <div className="flex flex-col">
                                                        <h3 className=" font-semibold">Nombre:</h3>
                                                        <input
                                                            type="text"
                                                            value={editandoUsuario.nombre}
                                                            onChange={(e) =>
                                                                setEditandoUsuario({ ...editandoUsuario, nombre: e.target.value })
                                                            }
                                                            className="border rounded-lg p-2 mb-2"
                                                            maxLength={50}
                                                        />

                                                        <h3 className=" font-semibold">Celular:</h3>
                                                        <input
                                                            type="text"
                                                            value={editandoUsuario.celular}
                                                            onChange={(e) =>
                                                                setEditandoUsuario({ ...editandoUsuario, celular: e.target.value })
                                                            }
                                                            className="border rounded-lg p-2 mb-2"
                                                            maxLength={10}
                                                        />

                                                        <h3 className=" font-semibold">Correo:</h3>
                                                        <input
                                                            type="email"
                                                            value={editandoUsuario.correo}
                                                            onChange={(e) =>
                                                                setEditandoUsuario({ ...editandoUsuario, correo: e.target.value })
                                                            }
                                                            className="border rounded-lg p-2 mb-2"
                                                            maxLength={30}
                                                        />

                                                        <h3 className=" font-semibold">Rol:</h3>
                                                        <input
                                                            type="text"
                                                            value={editandoUsuario.idperfil}
                                                            onChange={(e) =>
                                                                setEditandoUsuario({ ...editandoUsuario, idperfil: e.target.value })
                                                            }
                                                            className="border rounded-lg p-2 mb-2"
                                                            maxLength={50}
                                                        />

                                                        <div className="flex mt-4">
                                                            <button onClick={guardarUsuarioEditado} className="bg-green-500 text-white rounded px-2 py-1 mr-2">
                                                                Guardar
                                                            </button>
                                                            <button onClick={() => setEditandoUsuario(null)} className="bg-gray-500 text-white rounded px-2 py-1">
                                                                Cancelar
                                                            </button>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="flex flex-col">

                                                        <span><strong>Nombre:</strong> {usuario.nombre}</span>
                                                        <span><strong>Correo:</strong> {usuario.correo}</span>
                                                        <span><strong>Rol:</strong> {usuario.idperfil}</span>
                                                        <span><strong>Activo:</strong> {usuario.activo}</span>
                                                    </div>
                                                )}
                                            </div>

                                            {usuarioSeleccionado === usuario.idusuario && !editandoUsuario && (
                                                <>
                                                    <div className="flex items-center ">
                                                        <button
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                editarUsuario(usuario);
                                                            }}
                                                            className="bg-gray-500 text-white rounded px-2 py-1 mr-2 hover:bg-gray-400"
                                                        >
                                                            Editar Usuario
                                                        </button>
                                                        <button
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                confirmarEliminarUsuario(usuario);
                                                            }}
                                                            className="bg-red-600 text-white rounded px-2 py-1 mr-2 hover:bg-red-500"
                                                        >
                                                            Borrar Usuario
                                                        </button>
                                                    </div>
                                                    <div className="mt-12 space-y-2">
                                                        {/* Botón para Mostrar Roles */}
                                                        <button
                                                            onClick={() => setComponenteActivo("roles")}
                                                            className={`px-4 py-2 rounded ${componenteActivo === "roles" ? "bg-green-500 text-white" : "bg-gray-500 text-white"}`}
                                                        >
                                                            Roles
                                                        </button>

                                                        {/* Renderizar subcomponentes */}
                                                        {componenteActivo === "roles" && <Roles />}
                                                    </div>
                                                </>
                                            )}
                                        </li>
                                    ))}
                                </ul>

                                {/* Botón para agregar usuario */}
                                <div className="flex">
                                    <button
                                        onClick={() => setShowAgregarUsuarioModal(true)}
                                        className="bg-blue-500 text-white rounded px-4 py-2 mb-4 hover:bg-blue-400"
                                    >
                                        Agregar nuevo usuario
                                    </button>
                                </div>

                                {/* Modal para agregar un nuevo usuario */}
                                <ModalAgregarUsuario
                                    show={showAgregarUsuarioModal}
                                    onClose={() => setShowAgregarUsuarioModal(false)}
                                    onUsuarioAgregado={obtenerUsuarios}
                                />
                            </div>
                        </div>
                    </main>
                </>
            ) : (
                <p>No autorizado, por favor inicia sesión.</p>
            )}
        </>
    );
};

export default Usuarios;
